// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebase: {
    apiKey: "AIzaSyADMqeHEusPk6ysDYkOw-SNZSr6obGzT-w",
    authDomain: "talevation-tap-dev.firebaseapp.com",
    databaseURL: "https://talevation-tap-dev.firebaseio.com",
    projectId: "talevation-tap-dev",
    storageBucket: "talevation-tap-dev.appspot.com",
    messagingSenderId: "970991370712",
    appId: "1:970991370712:web:430e9edd380eae848cf2ad",
    measurementId: "G-CEM3VJMR7Z"
  },
  shopUrl: 'talevation-dev.myshopify.com'
};



/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
